import { render } from "./ServicesMetadata.vue?vue&type=template&id=e39b942c&scoped=true"
import script from "./ServicesMetadata.vue?vue&type=script&lang=js"
export * from "./ServicesMetadata.vue?vue&type=script&lang=js"

import "./ServicesMetadata.vue?vue&type=style&index=0&id=e39b942c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39b942c"]])

export default __exports__